import React from "react";
import { includes, get, isEmpty } from "lodash";
import { isPickBetSub } from "@tvg/sh-lib-my-bets/utils/raceDetails";
import {
  checkFavoriteSequence,
  getPayoutsHeaderTitle
} from "@tvg/sh-lib-my-bets/utils/runnerNumberGroupUtils";
import { BetSelection } from "@tvg/ts-types/Bet";
// @ts-ignore
import RunnerNumber from "../../_atom/RunnerNumber";
import {
  arrowForward
  // @ts-ignore
} from "../../_static/Icons/iconsDuotone";
// @ts-ignore
import buildColor from "../../_static/ColorPalette";
// @ts-ignore
import Icon from "../../_static/Icons";
import {
  RunnerNumberGroupMolecule,
  ListItem,
  RunnerNameContainer,
  RunnerName,
  FavArrowIcon,
  RunnerInfoContainer,
  ListItemWrapper,
  SelectionList
} from "./styled-components";

import AlternateRunners from "./components/AlternateRunners";
import PayoutsHeader from "./components/PayoutsHeader";
import PickBetLayout from "./components/PickBetLayout";
import ExoticBetsLayout from "./components/ExoticBetsLayout";
import ListItemDetails from "./components/ListItemDetails";

import {
  ListItemProps,
  MyBetsRunnerNumberGroupProps,
  ShortedSelectionsListProps
} from "./types";
import WillPaysDetails from "./components/WillPaysDetails";

const doubleEntryRegex = /^[0-9]+[a-zA-Z]+$/; // Double Entry validation regex

const getListItem = ({
  idx,
  runner,
  isMultiRace = false,
  isCanceled = false,
  isFavorite = false,
  isArrow = false,
  raceTypeCode,
  isUnknownWinnerStatus = false,
  betStatusName = "",
  isBetsDetailedView = false,
  allRunnersSelected = false,
  isLastRowOfRunners = false,
  isWinnerBI = false,
  wagerTypeCode,
  isRaceOver = false,
  isActiveMultiRaceLegOver = false,
  payoutsTitles = [],
  favoriteRunner,
  isCurrentRaceDate = false,
  isBetRefund = false,
  isDesktop
}: ListItemProps) => {
  const allowsPickBetSub = wagerTypeCode && isPickBetSub(wagerTypeCode);
  const runners = get(runner, "runners", []) || [];
  const showReplacement = runners.every(
    (currentRunner) => currentRunner.isScratched
  );
  const payoutsTitlesLength = payoutsTitles.length;
  const allRunnerIsScratched = get(runner, "runners", []).every(
    (currRunner) => currRunner.isScratched
  );
  const showTag =
    isBetRefund && allRunnerIsScratched && (isRaceOver || !isWinnerBI);

  const showDetails =
    isMultiRace &&
    !showTag &&
    (!allRunnerIsScratched || !runner?.alternate?.runners[0]?.isScratched) &&
    !isCanceled;

  const showWillPays = isDesktop
    ? !isCanceled && isBetsDetailedView && !isMultiRace
    : isBetsDetailedView && !isMultiRace;

  const runnerNumber = get(runner, "runnerNumber", "");

  const hasAvailableAlternateRunners = runner?.alternate?.runners.some(
    (altRunner) => !altRunner.isScratched
  );

  if (!isBetsDetailedView && allRunnersSelected) {
    return (
      <SelectionList
        key={`Runner${!isArrow ? runnerNumber : `_arrow_${idx}`}`}
        isBetsDetailedView={isBetsDetailedView}
        isDesktop={isDesktop}
      >
        <ListItemWrapper isBetsDetailedView={isBetsDetailedView}>
          <ListItem
            data-qa-label="runnerNumber-ListItem"
            isBetsDetailedView={false}
          >
            <RunnerInfoContainer
              isBetsDetailedView={isBetsDetailedView}
              cols={payoutsTitlesLength}
              betStatusName={betStatusName}
              isDesktop={isDesktop}
            >
              <RunnerNumber
                runnerId="All"
                raceTypeCode={raceTypeCode}
                isFavorite={false}
                isBetsStandalone
                isAllRunners
                isWinnerBI={!!runner?.isWinner}
                isUnknownWinnerStatus={isUnknownWinnerStatus}
                isActiveMultiRaceLegOver={
                  isActiveMultiRaceLegOver && !isBetsDetailedView
                }
              />
            </RunnerInfoContainer>
          </ListItem>
        </ListItemWrapper>
      </SelectionList>
    );
  }

  // Display alternate runners as replacements if at least one alternate in a coupled entry is not scratched.
  // If all alternates are scratched, skip them and proceed with rendering the favorite runner instead, inside the logic below.
  if (showReplacement && hasAvailableAlternateRunners && isRaceOver) {
    return (
      <SelectionList key={`alternate-runner-section-list-${idx.toString()}`}>
        <ListItemWrapper isBetsDetailedView={isBetsDetailedView}>
          {runner?.alternate?.runners
            .sort((a, b) => Number(a.isScratched) - Number(b.isScratched))
            .map((altRunner, alternateIndex) => (
              <ListItem
                key={`alternate-runner-${alternateIndex.toString()}`}
                data-qa-label="runnerNumber-ListItem"
                isBetsDetailedView={isBetsDetailedView}
              >
                <RunnerInfoContainer
                  isBetsDetailedView={isBetsDetailedView}
                  cols={payoutsTitlesLength}
                  betStatusName={betStatusName}
                  isDesktop={isDesktop}
                >
                  {alternateIndex === 0 &&
                    runners.map((mainScratchedRunner, mainScrIndex) => (
                      <RunnerNumber
                        key={`main-scratched-runner-${mainScrIndex.toString()}`}
                        qaLabel={`saddle-container-${mainScratchedRunner.runnerId}`}
                        runnerId={mainScratchedRunner.runnerId}
                        saddleColor={mainScratchedRunner.saddleColor}
                        numberColor={mainScratchedRunner.numberColor}
                        raceTypeCode={raceTypeCode}
                        isFavorite={isFavorite}
                        isBetsStandalone
                        isScratched={mainScratchedRunner.isScratched}
                        isWinnerBI={!!runner?.isWinner && !isCanceled}
                        isActiveMultiRaceLegOver={
                          isActiveMultiRaceLegOver && !isBetsDetailedView
                        }
                        isRaceOver={isRaceOver}
                        isBetsDetailedView={isBetsDetailedView}
                        isUnknownWinnerStatus={isUnknownWinnerStatus}
                      />
                    ))}
                  <>
                    {alternateIndex === 0 && (
                      <FavArrowIcon
                        icon={arrowForward}
                        viewBoxSize={16}
                        size={16}
                        color={buildColor("orange", "600")}
                      />
                    )}
                    <RunnerNumber
                      qaLabel={`saddle-container-${altRunner?.runnerId}`}
                      runnerId={altRunner?.runnerId}
                      saddleColor={altRunner.saddleColor}
                      numberColor={altRunner.numberColor}
                      raceTypeCode={raceTypeCode}
                      isFavorite={false}
                      isBetsStandalone
                      isScratched={altRunner.isScratched}
                      isWinnerBI={runner?.alternate?.isWinner ?? false}
                      isActiveMultiRaceLegOver={
                        isActiveMultiRaceLegOver && !isBetsDetailedView
                      }
                      isRaceOver={isRaceOver}
                      isBetsDetailedView={isBetsDetailedView}
                    />

                    {isBetsDetailedView && (
                      <RunnerNameContainer
                        data-qa-label={`runnerName-${altRunner?.runnerId}`}
                        isWinnerBI={
                          (runner?.alternate?.isWinner ?? false) && !isCanceled
                        }
                        isUnknownWinnerStatus={isUnknownWinnerStatus}
                        isActiveMultiRaceLegOver={
                          isActiveMultiRaceLegOver && isBetsDetailedView
                        }
                      >
                        <RunnerName
                          className="runner-name"
                          isScratched={altRunner?.isScratched ?? false}
                        >
                          {altRunner?.runnerName ?? ""}
                        </RunnerName>
                      </RunnerNameContainer>
                    )}
                  </>
                </RunnerInfoContainer>
              </ListItem>
            ))}
        </ListItemWrapper>

        {showWillPays && (
          <WillPaysDetails
            runner={runner}
            payoutsTitlesLength={payoutsTitlesLength}
            runnerNumber={runnerNumber}
            payoutsTitles={payoutsTitles}
          />
        )}
        {isBetsDetailedView && (
          <ListItemDetails
            isLastRowOfRunners={isLastRowOfRunners}
            isRaceOver={isRaceOver}
            isCanceled={isCanceled}
            runner={runner}
            isUnknownWinnerStatus={isUnknownWinnerStatus}
            isWinnerBI={!!runner?.isWinner || !!runner?.alternate?.isWinner}
            showDetails={showDetails}
            showTag={showTag}
            isBetRefund={isBetRefund}
          />
        )}
      </SelectionList>
    );
  }

  return (
    <SelectionList
      key={`Runner${!isArrow ? runnerNumber : `_arrow_${idx}`}`}
      isBetsDetailedView={isBetsDetailedView}
      isDesktop={isDesktop}
    >
      <ListItemWrapper isBetsDetailedView={isBetsDetailedView}>
        {runners.map((currentRunner, index) => {
          let toRender = null;
          if (isArrow && index === runners.length - 1) {
            toRender = (
              <Icon
                viewBoxSize={16}
                size={20}
                icon={arrowForward}
                color={buildColor("black", "100")}
              />
            );
          }

          if (!isArrow) {
            // Check if no favorite is available and all runners are scratched
            const allRunnersScratched = runners.every((r) => r.isScratched);
            const noFavoriteAvailable =
              !favoriteRunner || isEmpty(favoriteRunner);

            if (allRunnersScratched && noFavoriteAvailable) {
              toRender = (
                <RunnerInfoContainer
                  data-qa-label="main-saddle-row"
                  isBetsDetailedView={isBetsDetailedView}
                  cols={payoutsTitlesLength}
                  betStatusName={betStatusName}
                  isDesktop={isDesktop}
                >
                  <RunnerNumber
                    qaLabel={`saddle-container-${currentRunner.runnerId}`}
                    runnerId={currentRunner.runnerId}
                    saddleColor={currentRunner.saddleColor}
                    numberColor={currentRunner.numberColor}
                    raceTypeCode={raceTypeCode}
                    isFavorite={isFavorite}
                    isBetsStandalone
                    isScratched={currentRunner.isScratched}
                    isWinnerBI={isWinnerBI && !isCanceled}
                    isActiveMultiRaceLegOver={
                      isActiveMultiRaceLegOver && !isBetsDetailedView
                    }
                    isRaceOver={isRaceOver}
                    isBetsDetailedView={isBetsDetailedView}
                    isUnknownWinnerStatus={isUnknownWinnerStatus}
                  />

                  {isRaceOver && !isCanceled && (
                    <>
                      <FavArrowIcon
                        icon={arrowForward}
                        viewBoxSize={16}
                        size={16}
                        color={buildColor("orange", "600")}
                      />
                      <RunnerNumber
                        runnerId=""
                        raceTypeCode={raceTypeCode}
                        isFavorite={false}
                        isBetsStandalone
                        isScratched={false}
                        isWinnerBI={false}
                        isActiveMultiRaceLegOver={
                          isActiveMultiRaceLegOver && !isBetsDetailedView
                        }
                        isRaceOver={isRaceOver}
                        isBetsDetailedView={isBetsDetailedView}
                        isUnknownWinnerStatus={isUnknownWinnerStatus}
                      />
                    </>
                  )}
                </RunnerInfoContainer>
              );
            } else {
              toRender = (
                <>
                  <RunnerInfoContainer
                    isBetsDetailedView={isBetsDetailedView}
                    cols={payoutsTitlesLength}
                    betStatusName={betStatusName}
                    isDesktop={isDesktop}
                  >
                    <RunnerNumber
                      runnerId={currentRunner.runnerId}
                      raceTypeCode={raceTypeCode}
                      isFavorite={isFavorite}
                      isBetsStandalone
                      isScratched={currentRunner.isScratched}
                      isWinnerBI={isWinnerBI && !isCanceled}
                      isActiveMultiRaceLegOver={
                        isActiveMultiRaceLegOver && !isBetsDetailedView
                      }
                      isRaceOver={isRaceOver}
                      isBetsDetailedView={isBetsDetailedView}
                      isUnknownWinnerStatus={isUnknownWinnerStatus}
                    />
                    {allowsPickBetSub &&
                      isCurrentRaceDate &&
                      favoriteRunner &&
                      !isEmpty(favoriteRunner) &&
                      isRaceOver &&
                      showReplacement &&
                      !isCanceled && (
                        <>
                          <FavArrowIcon
                            icon={arrowForward}
                            viewBoxSize={16}
                            size={16}
                            color={buildColor("orange", "600")}
                          />
                          <RunnerNumber
                            runnerId={favoriteRunner?.runnerNumber}
                            raceTypeCode={raceTypeCode}
                            isFavorite={false}
                            isBetsStandalone
                            isScratched={false}
                            isWinnerBI={favoriteRunner?.isWinner}
                            isActiveMultiRaceLegOver={
                              isActiveMultiRaceLegOver && !isBetsDetailedView
                            }
                            isRaceOver={isRaceOver}
                            isBetsDetailedView={isBetsDetailedView}
                          />
                        </>
                      )}
                    {isBetsDetailedView && (
                      <RunnerNameContainer
                        data-qa-label={`runnerName-${currentRunner?.runnerId}`}
                        isWinnerBI={isWinnerBI && !isCanceled}
                        isUnknownWinnerStatus={isUnknownWinnerStatus}
                        isActiveMultiRaceLegOver={
                          isActiveMultiRaceLegOver && isBetsDetailedView
                        }
                      >
                        {allowsPickBetSub &&
                        isCurrentRaceDate &&
                        favoriteRunner &&
                        !!favoriteRunner?.runnerName &&
                        isRaceOver &&
                        showReplacement ? (
                          <RunnerName className="runner-name">
                            {favoriteRunner?.runnerName ?? ""}
                          </RunnerName>
                        ) : (
                          <RunnerName
                            className="runner-name"
                            isScratched={currentRunner?.isScratched ?? false}
                          >
                            {currentRunner?.runnerName ?? ""}
                          </RunnerName>
                        )}
                      </RunnerNameContainer>
                    )}
                  </RunnerInfoContainer>
                </>
              );
            }
          }

          if (toRender) {
            return (
              <ListItem
                data-qa-label="runnerNumber-ListItem"
                key={`runnerNumberGroup-${get(
                  runner,
                  "runnerNumber",
                  ""
                )}-${index.toString()}-${isFavorite ? "Fav" : "Nfav"}`}
                isBetsDetailedView={isBetsDetailedView}
              >
                {toRender}
              </ListItem>
            );
          }

          return toRender;
        })}
      </ListItemWrapper>

      {showWillPays && (
        <WillPaysDetails
          runner={runner}
          payoutsTitlesLength={payoutsTitlesLength}
          runnerNumber={runnerNumber}
          payoutsTitles={payoutsTitles}
        />
      )}
      {isBetsDetailedView && (showDetails || showTag) && (
        <ListItemDetails
          isLastRowOfRunners={isLastRowOfRunners}
          isRaceOver={isRaceOver}
          isCanceled={isCanceled}
          runner={runner}
          isUnknownWinnerStatus={isUnknownWinnerStatus}
          isWinnerBI={!!!!runner?.isWinner}
          showDetails={showDetails}
          showTag={showTag}
          isBetRefund={isBetRefund}
        />
      )}
    </SelectionList>
  );
};

export const getShortedSelectionsList = ({
  runners,
  favorites,
  raceTypeCode,
  isMultiRace = false,
  isUnknownWinnerStatus = false,
  wagerTypeCode,
  isRaceOver,
  isActiveMultiRaceLegOver,
  isCanceled = false,
  betStatusName = "",
  isDesktop
}: ShortedSelectionsListProps) => {
  let isFavorite;
  let lastFavoriteAdded = "";
  let startWithFavorite;
  let i = 0;
  const shortedSelections = [];

  while (i < runners.length) {
    const currentRunner = runners[i];
    const isScratched = currentRunner.runners.some(
      (r: { isScratched: boolean }) => r.isScratched
    );

    if (isScratched) {
      isFavorite = includes(favorites, currentRunner.runnerNumber);
      shortedSelections.push(
        getListItem({
          idx: i,
          runner: currentRunner,
          isMultiRace,
          isCanceled,
          isFavorite,
          raceTypeCode,
          isUnknownWinnerStatus,
          betStatusName,
          isWinnerBI: currentRunner?.isWinner ?? false,
          wagerTypeCode,
          isRaceOver,
          isActiveMultiRaceLegOver,
          isDesktop
        })
      );

      i += 1;
    } else {
      let count = 1;
      let countDE = 0;

      while (
        i + count < runners.length &&
        (doubleEntryRegex.test(runners[i + count].runnerNumber) ||
          parseInt(currentRunner.runnerNumber, 10) + (count - countDE) ===
            parseInt(runners[i + count].runnerNumber, 10))
      ) {
        if (
          runners[i + count].runners.some(
            (r: { isScratched: boolean }) => r.isScratched
          ) ||
          get(runners[i + count], "isWinner", false)
        ) {
          break;
        }
        if (doubleEntryRegex.test(runners[i + count].runnerNumber)) {
          countDE += 1;
        }
        count += 1;
      }

      startWithFavorite = 0; // new runners sequence starts with a favorite (0 -> false, 1 -> true)
      if (
        count === 2 &&
        checkFavoriteSequence(
          currentRunner,
          favorites,
          lastFavoriteAdded,
          doubleEntryRegex
        )
      ) {
        // check if the last runner added to the array was a favorite and if the next one is sequential to the favorite
        startWithFavorite = 1;
      }

      if (count + startWithFavorite > 2) {
        isFavorite = includes(favorites, currentRunner.runnerNumber);
        // Add first runner
        shortedSelections.push(
          getListItem({
            idx: i,
            runner: currentRunner,
            isMultiRace,
            isCanceled,
            isFavorite,
            raceTypeCode,
            isUnknownWinnerStatus,
            betStatusName,
            isWinnerBI: currentRunner?.isWinner ?? false,
            wagerTypeCode,
            isRaceOver,
            isActiveMultiRaceLegOver,
            isDesktop
          })
        );

        // Add arrow
        shortedSelections.push(
          getListItem({
            idx: i,
            runner: currentRunner,
            isMultiRace,
            isCanceled,
            isArrow: true,
            raceTypeCode,
            isUnknownWinnerStatus,
            betStatusName,
            isDesktop
          })
        );

        // Add the last runner of arrow
        const shortedIndex = i + count - 1;
        isFavorite = includes(favorites, runners[shortedIndex].runnerNumber);

        shortedSelections.push(
          getListItem({
            idx: shortedIndex,
            runner: runners[shortedIndex],
            isMultiRace,
            isCanceled,
            isFavorite,
            raceTypeCode,
            isUnknownWinnerStatus,
            betStatusName,
            isWinnerBI: runners[shortedIndex]?.isWinner ?? false,
            wagerTypeCode,
            isRaceOver,
            isActiveMultiRaceLegOver,
            isDesktop
          })
        );

        lastFavoriteAdded = isFavorite
          ? runners[i + count - 1].runnerNumber
          : "";

        i += count;
      } else {
        // Single entry
        isFavorite = includes(favorites, currentRunner.runnerNumber);
        lastFavoriteAdded = isFavorite ? currentRunner.runnerNumber : "";
        shortedSelections.push(
          getListItem({
            idx: i,
            runner: currentRunner,
            isMultiRace,
            isCanceled,
            isFavorite,
            raceTypeCode,
            isUnknownWinnerStatus,
            betStatusName,
            isWinnerBI: currentRunner?.isWinner ?? false,
            wagerTypeCode,
            isRaceOver,
            isActiveMultiRaceLegOver,
            isDesktop
          })
        );
        i += 1;
      }
    }
  }

  return <>{shortedSelections}</>;
};

const MyBetsRunnerNumberGroup = ({
  runners,
  favoriteRunners,
  raceTypeCode,
  isBetsDetailedView = false,
  isKey = false,
  label,
  showHorizontalRule = false,
  showUpperHorizontalRule = false,
  wagerTypeCode,
  onDetailedView,
  raceStatus,
  isFirstRowOfRunners = false,
  isLastRowOfRunners = false,
  allRunnersSelected = false,
  hasDetails = true,
  betStatusName,
  isPickBet = false,
  isCanceled = false,
  pickBetsLabelLength,
  favoriteRunner,
  isCurrentRaceDate = false,
  isBetRefund = false,
  isMultiRace = false,
  isExotic = false,
  isDesktop = false
}: MyBetsRunnerNumberGroupProps) => {
  const notScratchedRunners = runners.filter((runner) =>
    get(runner, "runners", []).every(
      (currentRunner) => !currentRunner.isScratched
    )
  );

  const runnersHaveWillPayAmount =
    !isCanceled &&
    !isBetRefund &&
    notScratchedRunners.length > 0 &&
    notScratchedRunners.some((runner) => get(runner, "willPayAmount", 0) > 0);

  const isRaceOver = ["winner", "canceled", "loser", "refunded"].includes(
    betStatusName
  );

  const isActiveMultiRaceLegOver =
    isMultiRace &&
    ["win", "lost"].includes(raceStatus) &&
    betStatusName === "active";

  const isUnknownWinnerStatus = raceStatus === "unknown";

  const hasScratchedRunners = runners.length > notScratchedRunners.length;

  const alternateRunners = runners[0]?.alternate?.runners ?? [];

  const hasAlternates = alternateRunners.length > 0;

  const alternateRunnerReplacement = alternateRunners.filter(
    (altRunner) => !altRunner.isScratched
  );
  const showAlternateReplacement =
    hasScratchedRunners && !!alternateRunnerReplacement.length && isRaceOver;

  const renderAllRunnersSelected = () => {
    const allSelections = [];

    allSelections.push(
      getListItem({
        idx: 0,
        runner: runners[0],
        isMultiRace,
        isCanceled,
        raceTypeCode,
        isUnknownWinnerStatus,
        betStatusName,
        allRunnersSelected,
        isActiveMultiRaceLegOver,
        isDesktop
      })
    );

    if (!isCanceled) {
      runners.forEach((runner, idx) => {
        if (get(runner, "isWinner", false)) {
          allSelections.push(
            getListItem({
              idx,
              runner,
              isMultiRace,
              isCanceled,
              raceTypeCode,
              isUnknownWinnerStatus,
              betStatusName,
              isWinnerBI: true,
              isDesktop
            })
          );
        }
      });
    }

    return allSelections;
  };

  const buildSaddleList = (payoutsTitles: Array<string> = []) => {
    if (!isBetsDetailedView && allRunnersSelected && !hasScratchedRunners) {
      return renderAllRunnersSelected();
    }

    if (
      !isBetsDetailedView &&
      runners.length > 3 &&
      notScratchedRunners.length > 0
    ) {
      return getShortedSelectionsList({
        runners,
        favorites: favoriteRunners ?? [],
        raceTypeCode,
        isMultiRace,
        isUnknownWinnerStatus,
        allRunnersSelected,
        wagerTypeCode,
        isRaceOver,
        isActiveMultiRaceLegOver,
        isCanceled,
        betStatusName,
        isDesktop
      });
    }

    return runners.map((biRunner, idx) =>
      getListItem({
        idx,
        runner: biRunner,
        isMultiRace,
        isCanceled,
        isFavorite: includes(favoriteRunners, biRunner.runnerNumber),
        raceTypeCode,
        isUnknownWinnerStatus,
        betStatusName,
        isBetsDetailedView,
        allRunnersSelected,
        isLastRowOfRunners,
        isWinnerBI: biRunner?.isWinner ?? false,
        wagerTypeCode,
        isRaceOver,
        isActiveMultiRaceLegOver,
        payoutsTitles,
        favoriteRunner,
        isCurrentRaceDate,
        isBetRefund,
        isDesktop
      })
    );
  };

  const renderRunnerNumberGroup = () => {
    const titles = getPayoutsHeaderTitle(
      wagerTypeCode,
      runners as BetSelection[]
    );
    return (
      <RunnerNumberGroupMolecule
        data-qa-label="runnerNumberGroup"
        isBetsDetailedView={isBetsDetailedView}
        betStatusName={betStatusName}
        raceStatus={raceStatus}
      >
        {isBetsDetailedView && (
          <PayoutsHeader
            titles={titles}
            isDesktop={isDesktop}
            isCanceled={isCanceled}
          />
        )}

        {buildSaddleList(titles)}

        {!showAlternateReplacement && alternateRunners.length > 0 && (
          <AlternateRunners
            alternateRunners={alternateRunners}
            isBetsDetailedView={isBetsDetailedView}
            isDesktop={isDesktop}
            titles={titles}
            betStatusName={betStatusName}
            raceTypeCode={raceTypeCode}
            isActiveMultiRaceLegOver={isActiveMultiRaceLegOver}
            isRaceOver={isRaceOver}
            isUnknownWinnerStatus={isUnknownWinnerStatus}
          />
        )}
      </RunnerNumberGroupMolecule>
    );
  };

  if (isExotic) {
    return (
      <ExoticBetsLayout
        isBetsDetailedView={isBetsDetailedView}
        label={label}
        isDesktop={isDesktop}
        isKey={isKey}
        showHorizontalRule={showHorizontalRule}
        runnerNumberGroup={renderRunnerNumberGroup()}
      />
    );
  }

  // Render Pick Bets
  if (isMultiRace) {
    return (
      <PickBetLayout
        runners={runners}
        isDesktop={isDesktop}
        isCanceled={isCanceled}
        isBetsDetailedView={isBetsDetailedView}
        onDetailedView={onDetailedView}
        isPickBet={isPickBet}
        isRaceOver={isRaceOver}
        raceStatus={raceStatus}
        label={label}
        wagerTypeCode={wagerTypeCode}
        hasAlternates={hasAlternates}
        hasAlternateReplacement={!!alternateRunnerReplacement.length}
        hasDetails={hasDetails}
        isFirstRowOfRunners={isFirstRowOfRunners}
        isLastRowOfRunners={isLastRowOfRunners}
        runnersHaveWillPayAmount={runnersHaveWillPayAmount}
        showHorizontalRule={showHorizontalRule}
        showUpperHorizontalRule={showUpperHorizontalRule}
        pickBetsLabelLength={pickBetsLabelLength}
        runnerNumberGroup={renderRunnerNumberGroup()}
      />
    );
  }

  // return default for simple bet types
  return renderRunnerNumberGroup();
};

export default MyBetsRunnerNumberGroup;
